import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimePeriodDTO  {
    _originalTypeClassName = "zERP.BO.TimePeriodDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimePeriodDTO.translate = translateService;
}
this.Years = null;
this.Months = null;
this.TimePeriodDTOKey = null;
this._key = this.TimePeriodDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Years:any;
Months:any;
private _TimePeriodDTOKey:any;
get TimePeriodDTOKey(): any {
    return this._TimePeriodDTOKey;
  }
set TimePeriodDTOKey(value: any) {
    this._TimePeriodDTOKey = value;
    this._key = value;
  }

static FromMonths($this: any, months: any): any{if (CLMS.Framework.Number.Equal(() => months, () => null) || CLMS.Framework.Number.LessThanOrEqual(() => months, () => 0)) {$this.Years = 0;$this.Months = 0;return;}
$this.Years = parseInt((Math.floor(Joove.Common.safeNumber(months) / Joove.Common.safeNumber(12))) as any);
$this.Months = parseInt(((Joove.Common.safeNumber(months) % Joove.Common.safeNumber(12))) as any);
}
static ToMonths($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.Years, () => null) || CLMS.Framework.Number.LessThan(() => $this.Years, () => 0)) {$this.Years = 0;}
if (CLMS.Framework.Number.Equal(() => $this.Months, () => null) || CLMS.Framework.Number.LessThan(() => $this.Months, () => 0)) {$this.Months = 0;}
if (CLMS.Framework.Number.GreaterThan(() => $this.Months, () => 12)) {let years = parseInt((Math.floor(parseFloat(((Joove.Common.safeNumber($this?.Months) / Joove.Common.safeNumber(12))) as any))) as any);$this.Years = Joove.Common.safeNumber($this?.Years) + Joove.Common.safeNumber(years);$this.Months = Joove.Common.cast((Joove.Common.safeNumber($this?.Months) % Joove.Common.safeNumber(12)), "number");}
return Joove.Common.safeNumber($this?.Years) * Joove.Common.safeNumber(12) + Joove.Common.safeNumber($this?.Months);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimePeriodDTOKey == null || $this.TimePeriodDTOKey == 0;
            }


}